<template>
  <GmapMap
    :center="defaultMapCenter"
    :zoom="4"

    style="width: 100%; height: 414px">
    <GmapMarker
      :key="index"
      v-for="(m, index) in markers"
      :icon="m.icon"
      :position="m.position"
      :clickable="true"
      @click="center=m.position"
    />
  </GmapMap>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'Map',

  props: {
    companyJobs: {
      type: Array
    }
  },

  data() {
    return {
      // Lebanon, Kansas - the middle of the US
      // ref: http://www.kansastravel.org/geographicalcenter.htm
      defaultMapCenter: { lat: 39.809797, lng: -98.55518 }
    }
  },

  async created() {
    if (this.isFactoring) {
      const factoringProviderKey = this.accountInfo.factoringProvider.factoringProviderKey
      await this.fetchExecutionLog({ factoringProviderKey })
    } else {
      await this.fetchExecutionLog()
    }
  },

  methods: {
    ...mapActions('companyJobs', {
      fetchTransactionList: 'fetch',
      fetchExecutionLog: 'fetchExecutionLogForInProgress'
    })
  },

  computed: {
    ...mapState('companyJobs', { allCompanyJobs: 'list' }),
    ...mapGetters('companyJobs', ['lastGpsEntry']),
    ...mapGetters('user', ['isFactoring', 'isShipper', 'accountInfo']),

    /**
     * Array of Google Map Markers, only for the latest GPS locations tho
     * @returns {*}
     */
    markers() {
      const transactionList = this.companyJobs || this.allCompanyJobs
      const jobKeysToMap = transactionList.map((transaction) => transaction.companyJobKey)

      return jobKeysToMap.map((key) => {
        return {
          position: this.lastGpsEntry(key),
          icon: '/map-marker-blue-dot.png'
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
